module.exports = __webpack_public_path__ + "static/media/md-musical-notes.c207ad35.svg";